/* TD Draft 2026-11-04 CART-RESERVE — see snippets/td-cart-reserve.liquid. Never touches the cart. */
(() => {
  if (customElements.get('td-cart-reserve')) return;

  const KEY = 'td_cart_reserve_start';
  const COUNT_KEY = 'td_cart_reserve_count';

  const read = (key) => {
    try {
      const value = parseInt(window.localStorage.getItem(key), 10);
      return Number.isFinite(value) ? value : null;
    } catch (e) {
      return null;
    }
  };

  const write = (key, value) => {
    try {
      if (value === null) {
        window.localStorage.removeItem(key);
      } else {
        window.localStorage.setItem(key, String(value));
      }
    } catch (e) {
      /* private mode or blocked storage: the timer then runs per page view */
    }
  };

  class TdCartReserve extends HTMLElement {
    connectedCallback() {
      const itemCount = parseInt(this.dataset.itemCount || '0', 10);
      const minutes = parseInt(this.dataset.minutes || '30', 10);

      if (!itemCount) {
        write(KEY, null);
        write(COUNT_KEY, null);
        this.hidden = true;
        return;
      }

      // Restart whenever an article was added since the last start (Felix 04.11.2026: timer was missing on an older cart)
      let start = read(KEY);
      const lastCount = read(COUNT_KEY);
      if (start === null || start > Date.now() || lastCount === null || itemCount > lastCount) {
        start = Date.now();
        write(KEY, start);
      }
      write(COUNT_KEY, itemCount);

      this.end = start + minutes * 60000;
      this.timeElement = this.querySelector('[data-time]');
      this.tick();

      if (!this.hidden) {
        this.interval = window.setInterval(() => this.tick(), 1000);
      }
    }

    disconnectedCallback() {
      window.clearInterval(this.interval);
    }

    tick() {
      const remaining = this.end - Date.now();

      if (remaining <= 0) {
        this.hidden = true;
        window.clearInterval(this.interval);
        return;
      }

      const seconds = Math.ceil(remaining / 1000);
      const text = `${String(Math.floor(seconds / 60)).padStart(2, '0')}:${String(seconds % 60).padStart(2, '0')}`;

      if (this.timeElement && this.timeElement.textContent !== text) {
        this.timeElement.textContent = text;
      }

      this.hidden = false;
    }
  }

  customElements.define('td-cart-reserve', TdCartReserve);
})();
